import React, { useEffect, useState } from "react";
import { ref, getDatabase, onValue } from "firebase/database";
import "../css/ProductList.css";
import { useNavigate, useParams } from "react-router-dom";
import { setProductDetailsItem } from "../localStorage";
import LoaderComponent from "../component/LoaderComponent";
import ContactUsFormComp from "../component/ContactUsFormComp";
import ContactUsModalView from "../component/ContactUsModalView";

const ProductList = () => {
	const [productListArray, setProductListArray] = useState([]);
	const [loader, setLoader] = useState(false);
	const param = useParams();
	const [showContactModal, setShowContactModal] = useState(false);
	const [selectedProduct, setSelectedProduct] = useState(null);
	const [messageSendFlag, setMessageSendFlag] = useState(false);

	const navigate = useNavigate();

	useEffect(() => {
		setLoader(true);
		const db = getDatabase();
		const compRef = ref(db, `productDetails/${param.id}`);

		const unsubscribe = onValue(compRef, (snapshot) => {
			if (snapshot.exists()) {
				const data = snapshot.val();
				const formatted = Object.keys(data).map((key) => ({
					...data[key],
					firebaseId: key,
				}));
				setProductListArray(formatted.reverse());
			} else {
				setProductListArray([]);
			}
			setLoader(false);
		});

		return () => {
			setLoader(false);
			unsubscribe();
		};
	}, [param.id]);

	useEffect(() => {
		if (messageSendFlag) {
			setShowContactModal(false);
			setMessageSendFlag(false);
		}
	}, [messageSendFlag]);

	return (
		<div className="container">
			{loader && <LoaderComponent />}

			{/* ===== Page Intro Section ===== */}
			<div className="product-page-intro">
				<h2>Our Premium Collection</h2>
				<p>
					Explore our carefully curated products designed to meet
					quality, reliability, and performance standards.
				</p>
			</div>

			<div className="product-highlights">
				<div className="highlight-box">
					<h4>✔ Quality Assured</h4>
					<p>Strict quality checks on every product we offer.</p>
				</div>
				<div className="highlight-box">
					<h4>✔ Reliable Support</h4>
					<p>Our experts are ready to assist you anytime.</p>
				</div>
				<div className="highlight-box">
					<h4>✔ Custom Solutions</h4>
					<p>Tailored products designed for your business needs.</p>
				</div>
			</div>

			{/* ===== Product List Header ===== */}
			<div className="product-list-header">Product List</div>

			{/* ===== Product List (UNCHANGED) ===== */}
			<div className="row product-list-container">
				{productListArray?.map((item) => (
					<div className="product-list my-5" key={item.firebaseId}>
						<div>
							<div
								onClick={() => {
									setProductDetailsItem(item);
									navigate("/productdetails");
									window.scrollTo(0, 0);
								}}
							>
								<img
									src={item?.postImageArray[0]?.url}
									alt={item?.productTitle}
								/>
							</div>

							<div className="product-list-short-details">
								<div className="product-list-title">
									<span>{item?.productTitle}</span>
								</div>

								<div
									className="product-list-ctn-btn"
									onClick={() => {
										setSelectedProduct(item);
										setShowContactModal(true);
									}}
								>
									<button>Contact Us</button>
								</div>
							</div>
						</div>
					</div>
				))}
			</div>

			{/* ===== Page Footer CTA ===== */}
			<div className="product-page-footer">
				<h3>Looking for something specific?</h3>
				<p>
					Contact our team for bulk orders, customization, or
					detailed product information.
				</p>
				<button onClick={() => setShowContactModal(true)}>
					Get in Touch
				</button>
			</div>

			{/* ===== Contact Modal ===== */}
			<ContactUsModalView
				isOpen={showContactModal}
				onClose={() => setShowContactModal(false)}
			>
				<ContactUsFormComp
					productId={selectedProduct?.productId}
					productTitle={selectedProduct?.productTitle}
					setMessageSendFlag={setMessageSendFlag}
				/>
			</ContactUsModalView>
		</div>
	);
};

export default ProductList;
